import { defineMessages } from 'react-intl-next';

export const messages: {
	for: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	isAssigned: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	created: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	for: {
		id: 'relay.jira-dc.work-item-status.for',
		defaultMessage: '{statusLozenge} for {dateLozenge}',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	isAssigned: {
		id: 'relay.jira-dc.work-item-assignee.assigned',
		defaultMessage:
			'{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
		description: 'Text that goes after assignee name',
	},
	created: {
		id: 'relay.jira-dc.work-item-creator.created',
		defaultMessage:
			'{created, select, internal {{firstName} created} other {External person created}}',
		description: 'Text that goes after creator name',
	},
});
